import React, { useEffect, useState } from "react";
import { Card, Form, Row, Col, Badge } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { toast } from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { FiHome, FiChevronRight } from "react-icons/fi";

import { getClassteacher } from "../../store/slices/classteacher";
import { getStudent } from "../../store/slices/student";
import { addAttendence } from "../../store/slices/attendence";

export default function AddAttendance() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const [rawData, setRawData] = useState([]);
    const [standards, setStandards] = useState([]);
    const [sections, setSections] = useState([]);
    const [students, setStudents] = useState([]);

    const [loadingStudents, setLoadingStudents] = useState(false);
    const [search, setSearch] = useState("");

    const today = new Date().toISOString().split("T")[0];

    const [formData, setFormData] = useState({
        standardId: "",
        sectionId: "",
        date: today,
    });

    const [errors, setErrors] = useState({});

    /* ---------- >  Fetch class teacher */
    useEffect(() => {
        const fetchData = async () => {
            try {
                const user = JSON.parse(localStorage.getItem("user"));
                const teacherId = user?.data?.teacherId;

                const res = await dispatch(
                    getClassteacher({ teacherId })
                ).unwrap();

                const data = res?.data || [];

                setRawData(data);

                const uniqueStandards = [
                    ...new Map(
                        data.map((i) => [i.standardId._id, i.standardId])
                    ).values(),
                ];

                setStandards(uniqueStandards);

                if (uniqueStandards.length === 1) {
                    const standardId = uniqueStandards[0]._id;

                    const sec = data
                        .filter((i) => i.standardId._id === standardId)
                        .map((i) => i.sectionId);

                    const uniqueSections = [
                        ...new Map(sec.map((s) => [s._id, s])).values(),
                    ];

                    setSections(uniqueSections);

                    if (uniqueSections.length === 1) {
                        const sectionId = uniqueSections[0]._id;

                        setFormData((prev) => ({
                            ...prev,
                            standardId,
                            sectionId,
                        }));

                        setLoadingStudents(true);

                        try {
                            const studentRes = await dispatch(
                                getStudent({
                                    standardId,
                                    sectionId,
                                })
                            ).unwrap();

                            const list = (studentRes?.data || []).map((s) => ({
                                ...s,
                                isPresent: true,
                            }));

                            setStudents(list);
                        } catch (error) {
                            console.log(error);
                            toast.error("Failed to fetch students");
                        } finally {
                            setLoadingStudents(false);
                        }
                    } else {
                        setFormData((prev) => ({
                            ...prev,
                            standardId,
                        }));
                    }
                }
            } catch (error) {
                console.log(error);
                toast.error("Failed to fetch class teacher");
            }
        };

        fetchData();
    }, [dispatch]);


    /* ---------------- > Handlers  */
    const handleStandardChange = (e) => {
        const standardId = e.target.value;

        setFormData({
            standardId,
            sectionId: "",
            date: formData.date,
        });

        setStudents([]);
        setSearch("");
        setErrors({});

        const sec = rawData
            .filter((i) => i.standardId._id === standardId)
            .map((i) => i.sectionId);

        setSections([...new Map(sec.map((s) => [s._id, s])).values()]);
    };

    const handleSectionChange = async (e) => {
        const sectionId = e.target.value;

        setFormData((prev) => ({ ...prev, sectionId }));
        setStudents([]);
        setSearch("");
        setErrors({});

        setLoadingStudents(true);
        try {
            const res = await dispatch(
                getStudent({
                    standardId: formData.standardId,
                    sectionId,
                })
            ).unwrap();

            const list = (res?.data || []).map((s) => ({
                ...s,
                isPresent: false,
            }));

            setStudents(list);
        } catch {
            toast.error("Failed to fetch students");
        } finally {
            setLoadingStudents(false);
        }
    };

    const handleDateChange = (e) => {
        setFormData((p) => ({ ...p, date: e.target.value }));
        setErrors((p) => ({ ...p, date: "" }));
    };

    const toggleAttendence = (id) => {
        setStudents((prev) =>
            prev.map((s) =>
                s._id === id ? { ...s, isPresent: !s.isPresent } : s
            )
        );
    };

    const handleSelectAll = () => {
        const allPresent = students.every((s) => s.isPresent);
        setStudents((prev) =>
            prev.map((s) => ({ ...s, isPresent: !allPresent }))
        );
    };

    // counter cal
    const totalCount = students.length;
    const presentCount = students.filter((s) => s.isPresent).length;
    const absentCount = totalCount - presentCount;

    //   validate
    const validate = () => {
        let err = {};
        if (!formData.standardId) err.standardId = "Please select standard";
        if (!formData.sectionId) err.sectionId = "Please select section";
        if (!formData.date) err.date = "Please select date";
        setErrors(err);
        return Object.keys(err).length === 0;
    };


    /* ---------------- >> Submit  */
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validate()) return;

        if (!students.length) {
            toast.error("No students found");
            return;
        }

        const attendanceStudents = students.map((s) => ({
            studentId: s._id,
            status: s.isPresent ? 1 : 0,
        }));

        const payload = {
            standardId: formData.standardId,
            sectionId: formData.sectionId,
            date: formData.date,
            students: attendanceStudents,
        };

        console.log("payload data : ", payload)

        try {
            await dispatch(addAttendence(payload)).unwrap();
            toast.success("Attendence added successfully");

            setTimeout(() => {
                window.location.reload();
            }, 1000);

        } catch (error) {
            console.log("Catch Error:", error);

            toast.error(error || "Failed to add attendance");
        }
    };

    const filteredStudents = students.filter((s) =>
        s.name.toLowerCase().includes(search.toLowerCase())
    );

    const styleTotal = {
        background: "linear-gradient(135deg, #667eea, #764ba2)",
        padding: "7px 10px",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "50px",
        boxShadow: "0 6px 15px rgba(102,126,234,.35)",
    }

    const stylepresent = {
        background: "linear-gradient(135deg, #22c55e, #16a34a)",
        padding: "7px 10px",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "50px",
        boxShadow: "0 6px 15px rgba(34,197,94,.35)",
    }

    const styleabsent = {
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        padding: "7px 10px",
        fontSize: "14px",
        fontWeight: "600",
        borderRadius: "50px",
        boxShadow: "0 6px 15px rgba(239,68,68,.35)",
    }


    return (
        <>
            <div className="page-header">
                <div className="breadcrumb-section">

                    {/* Left */}
                    <div className="breadcrumb-left">
                        <div className="home-icon">
                            <Link to="/teacher/home">
                                <FiHome style={{ color: "white", marginTop: "-4px" }} />
                            </Link>
                        </div>

                        <FiChevronRight className="separator" />
                        <span className="active">Add Attendance</span>
                    </div>

                    {/* Right */}
                    <div className="d-flex align-items-center gap-2 flex-wrap">
                        {/* total , present, absent */}
                        <div className="d-flex gap-3 flex-wrap">
                            <Badge
                                pill
                                style={styleTotal}
                            >
                                Total : {totalCount}
                            </Badge>

                            <Badge
                                pill
                                style={stylepresent}
                            >
                                Present : {presentCount}
                            </Badge>

                            <Badge
                                pill
                                style={styleabsent}
                            >
                                Absent : {absentCount}
                            </Badge>
                        </div>

                    </div>

                </div>
            </div>
            <Card className="an-card">
                <Card.Header className="an-header d-flex justify-content-between align-items-center">
                </Card.Header>

                <Card.Body>
                    <Form onSubmit={handleSubmit}>
                        <Row className="g-3">
                            <Col md={4}>
                                <Form.Label className="ab-form-label">Standard</Form.Label>

                                <Form.Select
                                    className="ab-premium-select"
                                    value={formData.standardId}
                                    onChange={handleStandardChange}
                                    disabled={standards.length === 1}
                                >
                                    <option value="">Select Standard</option>

                                    {standards.map((s) => (
                                        <option key={s._id} value={s._id}>
                                            {s.name}
                                        </option>
                                    ))}
                                </Form.Select>

                                {errors.standardId && (
                                    <small className="text-danger">{errors.standardId}</small>
                                )}
                            </Col>

                            <Col md={4}>
                                <Form.Label className="ab-form-label" >Section</Form.Label>
                                <Form.Select
                                    className="ab-premium-select"
                                    value={formData.sectionId}
                                    onChange={handleSectionChange}
                                    disabled={!sections.length}
                                    disabled={sections.length === 1 || !sections.length}
                                >
                                    <option value="">Select Section</option>
                                    {sections.map((s) => (
                                        <option key={s._id} value={s._id}>
                                            {s.name}
                                        </option>
                                    ))}
                                </Form.Select>
                                {errors.sectionId && (
                                    <small className="text-danger">{errors.sectionId}</small>
                                )}
                            </Col>

                            <Col md={4}>
                                <Form.Label className="ab-form-label" >Date</Form.Label>
                                <Form.Control
                                    type="date"
                                    value={formData.date}
                                    onChange={handleDateChange}
                                    max={new Date().toISOString().split("T")[0]}
                                    className="ab-premium-select"
                                />

                                {errors.date && (
                                    <small className="text-danger">{errors.date}</small>
                                )}
                            </Col>
                        </Row>

                        {loadingStudents && <p className="mt-3">Loading students…</p>}

                        {!loadingStudents && students.length > 0 && (
                            <Card className="mt-4">
                                <Card.Header className="d-flex justify-content-between align-items-center">
                                    <Form.Check
                                        type="checkbox"
                                        label="Select All (Present)"
                                        checked={students.every((s) => s.isPresent)}
                                        onChange={handleSelectAll}
                                    />

                                    <Form.Control
                                        type="text"
                                        placeholder="Search student"
                                        value={search}
                                        onChange={(e) => setSearch(e.target.value)}
                                        style={{ maxWidth: "220px" }}
                                    />
                                </Card.Header>

                                <Card.Body style={{ maxHeight: 320, overflowY: "auto" }}>
                                    {filteredStudents.map((s) => (
                                        <div
                                            key={s._id}
                                            className="d-flex justify-content-between align-items-center mb-2"
                                        >
                                            <Form.Check
                                                type="checkbox"
                                                label={`${s.name} (${s.rollNo || "-"})`}
                                                checked={s.isPresent}
                                                onChange={() => toggleAttendence(s._id)}
                                            />

                                            {s.isPresent ? (
                                                <Badge bg="success" style={stylepresent}>Present</Badge>
                                            ) : (
                                                <Badge bg="danger"
                                                    style={styleabsent}
                                                >Absent</Badge>
                                            )}
                                        </div>
                                    ))}
                                </Card.Body>
                            </Card>
                        )}

                        <div className="an-actions mt-4">
                            <button
                                type="button"
                                className="btn-cancel"
                                onClick={() =>
                                    navigate("/teacher/attendance", {
                                        state: {
                                            fromAddAttendance: true,
                                        },
                                    })}
                            >
                                Cancel
                            </button>
                            <button type="submit" className="btn-submit">
                                Submit
                            </button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>
        </>

    );
}
